import { render, staticRenderFns } from "./Palma.vue?vue&type=template&id=2f28c229&"
import script from "./Palma.vue?vue&type=script&lang=js&"
export * from "./Palma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports